import {
  AxiosErrorCode,
  CPSConstants,
  CPSMessages,
  CPSNumbers,
  HttpStatusCode,
  PageNames,
} from "commonUtils/enumerations";
import {loggedMessage, message} from "commonUtils/utils";
import {
  HttpException,
  ServiceAuthenticationException,
} from "services/exceptionHandlerService";
const currentYear = new Date().getFullYear();
export interface DataVerificationDialogProps {
  dvYears: number;
}
export interface AdvanceSearchFormValues {
  lastName: string;
  firstName: string;
  city: string;
  stateId: number;
  facultyIds: string;
  lillyPersonIds: string;
  telephoneNumber: string;
  email: string;
  credentialIds: string;
  specialtyIds: string;
  brandIds: string;
  languageIds: string;
  boardCertificationIds: string;
  affiliation: string;
  tierLevel: number;
  contractedYear: number;
  isContracted: number;
  cvBioKeywords: string;
  availableOnIds: string;
  programFormatIds: string;
  groupSize: number;
  isTravelNationwide: number;
  isMyList: boolean;
  profileId: number;
  supplierId: number;
  groupId: number;
  llyReadOnlyUser: boolean;
  roles: string;
  isDOL: boolean;
}

export const defaultAdvanceSearchObj = {
  lastName: "",
  firstName: "",
  city: "",
  stateId: -1,
  facultyIds: "",
  lillyPersonIds: "",
  telephoneNumber: "",
  email: "",
  credentialIds: "",
  specialtyIds: "",
  brandIds: "",
  languageIds: "",
  boardCertificationIds: "",
  affiliation: "",
  tierLevel: -1,
  contractedYear: currentYear,
  isContracted: -1,
  cvBioKeywords: "",
  availableOnIds: "",
  programFormatIds: "",
  groupSize: -1,
  isTravelNationwide: -1,
  isMyList: false,
  profileId: 0,
  supplierId: 0,
  groupId: 0,
  llyReadOnlyUser: true,
  roles: "",
};

export const triggerFormValues = {
  ppqYear: -1,
  ppqInitialRequester: {
    id: -1,
  },
  ppqAdditionalRequester: -1,
};

export interface getHeaderClassNameProps {
  field: string | undefined;
  flex?: number | undefined;
  headerName?: string | undefined;
}

export interface PPQFormValues {
  ownershipYear: number;
  ownershipBrandIds: string;
  ownershipTypeId: number;
  isContracted: number;
  lastPPQRequestedStartDate: string | null | any;
  lastPPQRequestedEndDate: string | null | any;
  isExcludeNullRecords: boolean;
  lastPPQCompletedStartDate: string | null | any;
  lastPPQCompletedEndDate: string | null | any;
  ppqYear: number;
  ppqStatusId: number;
  ppqInitialRequesterId: number | null | any;
  medicalContractStartDate: string | null | any;
  medicalContractEndDate: string | null | any;
  medicalConsultantStatusIds: string;
  ppqFacultySheetFile: string;
  profileId: number;
  roles: string;
}

export const defaultPPQValuesObj = {
  ownershipYear: currentYear,
  ownershipBrandIds: "",
  ownershipTypeId: -1,
  isContracted: -1,
  lastPPQRequestedStartDate: null,
  lastPPQRequestedEndDate: null,
  isExcludeNullRecords: false,
  lastPPQCompletedStartDate: null,
  lastPPQCompletedEndDate: null,
  ppqYear: -1,
  ppqStatusId: -1,
  ppqInitialRequesterId: 0,
  medicalContractStartDate: null,
  medicalContractEndDate: null,
  medicalConsultantStatusIds: "",
  ppqFacultySheetFile: "",
  profileId: 0,
  roles: "",
};

export interface ProfileFormNotes {
  isScreeningOverrideChecked: boolean;
  screeningFacultyNotes: string;
}

export const defaultScreenNotes = {
  isScreeningOverrideChecked: false,
  screeningFacultyNotes: "",
};

export const defaultBreadCrumbs = {
  id: 0,
  breadCrumbName: "",
  displayText: "",
  displayOrder: 0,
  menuItemId: 0,
  pageToLoad: "",
  typeStatus: 0,
};

export const defaultDocumentUpload = {
  isScreeningOverrideChecked: false,
  isOverrideDurationChecked: false,
  isContractEndDateEnabled: false,
  isOverrideDurationEnabled: false,
  facultyName: "",
  method: "",
  facultyAddress: `${CPSConstants.HOME}`,
  ppqYears: currentYear,
  dvYears: currentYear,
  profileDocumentType: CPSNumbers.MINUS_ONE,
  contractKey: "",
  activityTypeId: CPSNumbers.MINUS_ONE,
  activity: "",
  startDate: null,
  endDate: null,
  activityId: CPSNumbers.ZERO,
  isAdvising: false,
  hourlyRate: "",
  approvedBy: "",
  approvedDate: null,
  myFile: {},
  myFileBase64: "",
  isOUS: false,
};

export interface UploadFormValues {
  myFile: any;
  myFileBase64: string;
}

export interface FacultyAdvancedSearchProps {
  handleSubmitFaculty?: any;
}

export interface FacultyRowValue {
  cityState: string;
  facultyId: number;
  facultyName: string;
  specialty: string;
}

export interface BasicSearchFormValues {
  lastName: string;
  firstName: string;
  facultyId: number | string;
  city: string;
  stateId: number;
  brandId: number;
  contractedId: number;
  facultyTypeIds: string;
}

export interface TriggerFormValues {
  method: string;
  ppqYear: number;
  ppqInitialRequester: {
    id: number | undefined;
    name: string | undefined;
  };
  ppqAdditionalRequester: number | string;
}

export interface ProfileFormValuesProps {
  isScreeningOverrideChecked: boolean;
  isOverrideDurationChecked: boolean;
  isContractEndDateEnabled: boolean;
  isOverrideDurationEnabled: boolean;
  facultyName: string;
  method: string;
  facultyAddress: string;
  ppqYears: number;
  dvYears: number;
  profileDocumentType: number;
  contractKey: number | string;
  activityTypeId: number;
  activityId: number;
  startDate: string | null;
  activity: string | null;
  endDate: string | null;
  isAdvising: boolean;
  hourlyRate: string;
  approvedBy: string;
  approvedDate: string | null;
  isOUS: boolean;
  myFileBase64: string;
  myFile: any;
}

export interface DataVerificationProps {
  dvStartDateTooltipText: string;
  dvStartDate: string;
  isScreeningCompleted: boolean;
  screeningStatus: string;
  isPPQCompleted: boolean;
  ppqStatus: string;
  dvStatusTooltipText: string;
  dvStatus: string;
  isDVStatusSectionVisible: boolean;
  dvStatusSectionDetails: {
    isOnboardCompleted: boolean;
    isContactCompleted: boolean;
    isInstitutionCompleted: boolean;
    isPaymentCompleted: boolean;
    isSummaryCompleted: boolean;
  };
  dvCompletedDateTooltipText: string | null;
  dvCompletedDate: string | null;
  verifiedDataTooltipText: string;
  isVerifiedDataLinkVisible: boolean;
}

export interface PPQInformationProps {
  ppqStatus: string;
  ppqRequester: string;
  ppqInitialEmailSent: null;
  ppqLastReminderSent: null;
  ppqStatusUpdatedWhen: null;
}

export interface DataVerificationDetailsProps {
  dvYears: [
    {
      id: number;
      name: string;
    },
  ];
  dvSections: [
    {
      id: number;
      section: string;
      notCompletedText: string;
    },
  ];
  dvSectionHeaders: [
    {
      id: number;
      sectionHeader: string;
      orderBy: number;
    },
  ];
  dvStepSectionHeaders: [
    {
      id: number;
      sectionHeader: string;
      orderBy: number;
    },
  ];
  dvSectionDetails: {
    configuredDataVerificationStartDate: string;
    status: string;
    dataVerificationCompletedDate: string;
    faculty: string;
  };
  dvStepDetails: [
    {
      stepId: number;
      type: number;
      before: number;
      after: number;
      action: number;
    },
  ];
}

export interface ProfileDocumentControlsProps {
  isDocumentTypeDropdownDisabled: false;
  documentTypes: [
    {
      id: number;
      name: string;
    },
  ];
  selectedDocumentTypeId: number;
  activityTypes: [
    {
      id: number;
      description: string;
    },
  ];
  pdfFileSizeInMB: number | undefined | null | any;
  photoFileSizeInMB: number | undefined | null | any;
}
export interface DateMsgs {
  emptyStrtDate: message;
  emptyEndDate: message;
  notSameYear: message;
  notValidRange: message;
}

export interface MiscellaneousGridDataProps {
  potentialConflictDates: [
    {
      dateId: number;
      startDate: string;
      endDate: string;
    },
  ];
}

export interface MiscellaneousDataProps {
  isSpeakForOtherCompanies: boolean;
  isParticipatedAsClinicalInvestigator: boolean;
  isDiscussedWithPhysicians: boolean;
  languageIds: string;
  ownerNumber: string;
  conferenceDialInNumber: string;
  messageCode: number;
  message: string | null;
  isSuccessMessage: boolean;
  isErrorMessage: boolean;
  isValidationMessage: boolean;
}

export interface DialogTextProps {
  showDialog: boolean;
  title?: string;
  label?: string;
  description?: string;
  buttonTextOne?: string;
  buttonTextTwo?: string;
}

export interface SpecialityProps {
  specialty: string;
}

export interface TierLevelProps {
  tierLevel: string;
}

export interface CalendarCountsProps {
  Subject: string;
  StartTime: string;
  EndTime: string;
  activityCount: number;
}

export interface FacultyCalendarActivitiesProps {
  facultyCalendarActivities: [
    {
      activityIdentity: string;
      activityURL: string;
      activityInfoSheetURL: string;
      activityDescription: string;
      startDateTime: string;
      addressCityState: string;
      brand: string;
    },
  ];
  totalRecordsCount: number;
  messageCode: number;
  message: string | null;
  isSuccessMessage: boolean;
  isErrorMessage: boolean;
  isValidationMessage: boolean;
}

export interface ActivityTypesProps {
  id: number;
  description: string;
}

export interface AllianceGroupsProps {
  id: number;
  name: string;
  activityTypeId: number;
  status: number;
}

export interface TierTypesProps {
  id: number;
  name: string;
  activityTypeId: number;
  allianceGroupId: number;
  status: number;
}

export interface ReasonsProps {
  id: number;
  name: string;
}

export interface StatusesProps {
  id: number;
  name: string;
}

export interface ZeroTierYearsProps {
  id: number;
  name: string;
}

export const weekdaysList = [
  {id: 7, name: "Sun"},
  {id: 1, name: "Mon"},
  {id: 2, name: "Tue"},
  {id: 3, name: "Wed"},
  {id: 4, name: "Thu"},
  {id: 5, name: "Fri"},
  {id: 6, name: "Sat"},
];

export const capitalizeFirstLetter = (value: string, errorMsg: string) => {
  try {
    if (!value) return value;
    return value.charAt(0).toUpperCase() + value.slice(1);
  } catch (error: any) {
    loggedMessage(error, errorMsg, PageNames.FACULTY);
  }
};

export const handleCheckboxChange = (
  e: any,
  id: number,
  selectedDays: any[],
  setSelectedDays: (arg0: any) => void,
  setValue: any,
  errorMsg: any,
) => {
  try {
    const {checked} = e.target;
    let list = [];
    if (checked) {
      list = [...selectedDays, id];
    } else {
      list = selectedDays.filter((day: any) => day !== id);
    }
    setSelectedDays(list);
    setValue("availableOnIds", list.toString());
  } catch (error: any) {
    loggedMessage(error, errorMsg, PageNames.FACULTY);
  }
};

export const handleAxiosErrors = (
  error: any,
  setErrorMsg: (arg0: CPSMessages) => void,
) => {
  const data = {pagename: PageNames.FACULTY};
  if (
    error?.code === AxiosErrorCode.ERR_BAD_REQUEST ||
    error?.code === AxiosErrorCode.ERR_BAD_RESPONSE
  ) {
    if (
      error?.response?.status === HttpStatusCode.UNAUTHORIZED ||
      error?.response?.status === HttpStatusCode.FORBIDDEN
    ) {
      ServiceAuthenticationException(error, data, error?.response?.status);
    } else if (error?.response?.status === HttpStatusCode.BAD_REQUEST) {
      setErrorMsg(error.response.data.message);
      // setServerValidation(error.response.data);
    } else if (error?.response?.status === HttpStatusCode.NOT_FOUND) {
      setErrorMsg(CPSMessages.SERVICE_NOT_FOUND);
    } else if (
      error?.response?.status === HttpStatusCode.INTERNAL_SERVER_ERROR
    ) {
      HttpException(error, data);
      setErrorMsg(CPSMessages.INTERNAL_SERVER_ERROR);
    } else {
      setErrorMsg(error.message);
    }
  } else if (error?.code === AxiosErrorCode.ECONNABORTED) {
    setErrorMsg(CPSMessages.TIMEOUT_ERROR);
  } else if (error?.code === AxiosErrorCode.ERR_NETWORK) {
    setErrorMsg(CPSMessages.NETWORK_ERROR);
  } else {
    setErrorMsg(error.message);
  }
};

export const handelDropDownListBasedOnRegion = async (
  selectedCode: string,
  allPlaces: any,
  labelKey: string,
  setPlaces: React.Dispatch<React.SetStateAction<any>>,
) => {
  let selectedCodeArray: string[] = [];
  if (selectedCode?.includes(",")) {
    selectedCodeArray = selectedCode.split(",");
  } else {
    selectedCodeArray = [selectedCode];
  }

  const placeBySelectedCode = await allPlaces?.filter((data: any) => {
    return selectedCodeArray?.includes(`${data?.[labelKey]}`);
  });
  if (placeBySelectedCode?.length > 0) {
    placeBySelectedCode?.unshift(allPlaces[0]);
  }

  setPlaces(placeBySelectedCode?.length ? [...placeBySelectedCode] : []);
};

export interface AddFacultyHCPFormValues {
  salutation: string;
  firstName: string;
  middleInitial: string;
  lastName: string;
  suffix: string;
  isCRP: false;
  approver1Id: string;
  approver1Name: string;
  approver2Id: string;
  approver2Name: string;
  preferredAddressType: string;
  w9AddressType: string;
  comment: string;
}

export interface FacultyAddress {
  facultyAddressId: number;
  addressTypeId: string;
  addressType: string;
  affiliation: string;
  address1: string;
  address2: string;
  city: string;
  stateId: number;
  postalCode: string;
  countryId: number;
  telephoneNumber: string;
  extension: number;
  mobileNumber: string;
  pagerNumber: string;
  faxNumber: string;
  email: string;
  title: string;
  assistantName: string;
  assistantTelephoneNumber: string;
  assistantPagerNumber: string;
  assistantEmail: string;
  status: number;
  addressTypeLabel: string;
  thirdPartyName: string;
  userDetails: string;
  mailingVisible?: boolean;
}
export interface Savefaculty {
  brandSelected: any;
  facultyId: number; // 0 for New, for existing it is coming for URL 'FacultyRequestId' parameter
  facultyRequestId: number;
  facultyTypeId: number; // 1 (HCP), 2 (Patient/Caregiver), 3 (Non-HCP)
  lillyCustomerId: string;
  salutation: string;
  firstName: string;
  middleInitial: string;
  lastName: string;
  suffix: string;
  specialty1Id: number;
  specialty2Id: number;
  credentials1Id: string;
  credentials2Id: string;
  boardCertification1Id: number;
  boardCertification2Id: number;
  brandIds: string;
  isCRP: boolean;
  initialRequesterId: number;
  isBILillyHCP: number;
  contractingYear: number;
  preferredAddressType: string;
  w9AddressType: string;
  voiceMail: string;
  preferred1099Address: string;
  facultyAddressInfos: [
    {
      facultyAddressId: number;
      addressTypeId: string;
      affiliation: string;
      address1: string;
      address2: string;
      city: string;
      stateId: number;
      postalCode: string;
      countryId: number;
      telephoneNumber: string;
      extension: number;
      mobileNumber: string;
      pagerNumber: string;
      faxNumber: string;
      email: string;
      title: string;
      assistantName: string;
      assistantTelephoneNumber: string;
      assistantPagerNumber: string;
      assistantEmail: string;
      status: number;
    },
  ];
  comment: string;
  approver1Id: string;
  approver1Name: string;
  approver2Id: string;
  approver2Name: string;
  isMedical: boolean;
  profileId: number;
  switchedProfileId: number;
}
export interface facultyAddress {
  facultyAddressId: number;
  addressTypeId: string;
  affiliation: string;
  address1: string;
  address2: string;
  city: string;
  stateId: number;
  postalCode: string;
  countryId: number;
  telephoneNumber: string;
  extension: number;
  mobileNumber: string;
  pagerNumber: string;
  faxNumber: string;
  email: string;
  title: string;
  assistantName: string;
  assistantTelephoneNumber: string;
  assistantPagerNumber: string;
  assistantEmail: string;
  status: number;
  addressTypeLabel: string;
  thirdPartyName: string;
  userDetails: string;
  mailingVisible?: boolean;
}
export interface AddFacultyHCPProfileValues {
  salutation: string;
  lillyCustomerId: string;
  firstName: string;
  middleInitial: string;
  lastName: string;
  suffix: string;
  specialty1Id: string;
  specialty2Id: string;
  credentials1Id: string;
  credentials2Id: string;
  boardCertification1Id: string;
  boardCertification2Id: string;
  brandIds: string;
  isBILillyHCP: false;
  initialRequesterId: any;
  contractingYear: string;
  isCRP: false;
}

export interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

export interface TabListProps {
  id: number;
  name: string;
  component: React.ReactNode | string;
}

export interface FilterListProps {
  id: number;
  name: string;
}

export interface ActivityTypeListProps {
  id: number;
  description: string;
}

export interface ContractTypeListProps {
  id: number;
  activityTypeId: number;
  name: string;
}

export interface TrainingFormType {
  statusId: number;
  brandId: number;
  year: number;
}

export interface TrainingListProps {
  id: number;
  name: string;
}

export interface ContractFormType {
  activityTypeId: number;
  contractTypeId: number;
  year: number;
}

export interface InstitutionFormType {
  isInstitutionEmployer: boolean | null;
  isSpeakPromotionally: boolean | null;
  isPromotionalContent: boolean | null;
  firstName: string;
  lastName: string;
  institutionName: string;
  phone: string;
  email: string;
}

export interface InstitutionTextType {
  name: string;
  id: number;
  isVisible: boolean;
}

export interface BrandTopicsListProps {
  brandDetail: string;
  topicDescription: string;
  trainedOn: string;
}

export interface ViewMyListFormValues {
  pageIndex: number;
  pageSize: number;
  sortCol: string;
  sortOrder: string;
  requestId: number;
  action: number;
  reason: string;
}

export interface MyListRowId {
  listId: number;
}

export interface MyListRowValue {
  addedWhen: Date;
  descriptions: string;
  facultyCount: number;
  listId: number;
  listName: string;
}

export interface MyListFormInputs {
  listName: string;
  descriptions: string;
}

export interface SelectedMarkerData {
  position: {
    lat: number;
    lng: number;
  };
  zoom: number;
  id: number;
  stateId?: string | undefined;
}
export interface TaxYear {
  id: number;
  name: string;
}

export interface TierDefaultValuesPros {
  method: string;
  activityTypeId: number;
  allianceGroupId: number;
  reasonId: number;
  tierTypeId: number;
  nextYearTierId: number;
  statusId: number;
  zeroTierYears: number;
  effectiveEndDate: string;
  effectiveStartDate: string;
  isEditNextYearTierChecked: boolean;
}

export const TierDefaultValues: TierDefaultValuesPros = {
  method: "",
  activityTypeId: -1,
  allianceGroupId: -1,
  reasonId: -1,
  tierTypeId: -1,
  nextYearTierId: -1,
  statusId: -1,
  zeroTierYears: -1,
  effectiveEndDate: "",
  effectiveStartDate: "",
  isEditNextYearTierChecked: false,
};

export interface TierLevelsProps {
  tierId: number;
  activityTypeId: number;
  activityType: string;
  allianceGroupId: number;
  allianceGroup: string;
  tierTypeId: number;
  tierType: string;
  points: number;
  specialty: string | null;
  credentials: string | null;
  effectiveStartDate: string;
  effectiveEndDate: string;
  reasonId: number;
  reason: string;
  statusId: number;
  status: string;
  addedByAddedWhen: string;
  updatedByUpdatedWhen: string | null;
  isEditIconVisible: boolean;
  isDeleteIconVisible: boolean;
  isNextYearTierRowVisible: boolean;
  nextYearTierId: number;
}

export interface EditTierLevelsProps {
  tierId: number;
  activityTypeId: number;
  activityType: string;
  allianceGroupId?: number;
  allianceGroup: string;
  tierTypeId: number;
  tierType: string;
  points: number;
  specialty: string | null;
  credentials: string | null;
  effectiveStartDate: string;
  effectiveEndDate: string;
  reasonId: number;
  reason: string;
  statusId: number;
  status: string;
  addedByAddedWhen: string;
  updatedByUpdatedWhen: string | null;
  isEditIconVisible: boolean;
  isDeleteIconVisible: boolean;
  isNextYearTierRowVisible: boolean;
  nextYearTierId: number;
}

export interface AddORDeleteTierLevelsProps {
  method: string;
  facultyId?: number;
  tierId?: number;
  activityTypeId: number;
  allianceGroupId: number;
  reasonId: number;
  tierTypeId: number;
  statusId: number;
  effectiveStartDate: string;
  effectiveEndDate: string;
  isEditNextYearTierChecked: boolean;
  nextYearTierId: number;
  isDeleted?: boolean;
  profileId?: number;
  zeroTierYears: number;
  switchedProfileId?: number;
}

export interface FacultyTopicInfoProps {
  id: number;
  name: string;
}

export interface SelectFacultyTopicInfoProps {
  rowNumber: number;
  id: number;
  brandDetail: string;
  topic: string;
  status: string;
  trainedOn: string;
  topicKey: number;
  speakerStatus: string;
}

export interface FacultyTopicInfoBrandsProps {
  id: number;
  name: string;
}

export interface FacultyTopicForBrandsProps {
  topicId: number;
  topicDescription: string;
  productId: number;
}
export interface FacultyOptInListProps {
  name: string;
  id: number;
}
export interface TravelDocumentsListProps {
  documentId: number;
  documentName: string;
  fileExtension: string;
  updatedWhen: string;
  updatedByName: string;
}
export interface DocumentOperationsProps {
  facultyId: number;
  documentId: number;
  operation: string;
  documentName: string;
  file: string;
  fileName: string;
  fileExtension: string;
  profileId: number;
}
export interface FacultyCvBioProps {
  name: string;
  id: number;
}

export interface DocumentInformationProps {
  documentId: number;
  documentTypeId: number;
  isRadioButtonVisible: boolean;
  isRadioButtonSelected: boolean;
  radioButtonText: null;
  isDocumentEnabled: boolean;
  isDocumentChecked: boolean;
  isReceivedWhenEnabled: boolean;
  receivedWhen: null;
  isTypeEnabled: boolean;
  typeId: number;
  isPIRemovedVisible: boolean;
  isPIRemovedEnabled: boolean;
  isPIRemoved: boolean;
  isSentToFacultyVisible: boolean;
  isSentToFacultyEnabled: boolean;
  isSentToFaculty: boolean;
  isApprovedVisible: boolean;
  isApprovedEnabled: boolean;
  isApproved: boolean;
  isApprovedWhenVisible: boolean;
  isApprovedWhenEnabled: boolean;
  approvedWhen: null;
  isUploadedVisible: boolean;
  isUploadedEnabled: boolean;
  isUploaded: boolean;
  isUploadedWhenVisible: boolean;
  isUploadedWhenEnabled: boolean;
  uploadedWhen: null;
  isSentToAccountingVisible: boolean;
  isSentToAccountingEnabled: boolean;
  isSentToAccounting: boolean;
  isSentWhenVisible: boolean;
  isSentWhenEnabled: boolean;
  sentWhen: null;
  status: number;
}

export interface FacultySpeakerProgramPreferencesBrandListProps {
  name: string;
  id: number;
}

export interface ExceptionType {
  expenseExceptionTypeId: number;
  description: string;
}

export interface NotifyHow {
  expenseNotifiedHowId: number;
  description: string;
}

export interface ProductGroup {
  productGroupId: number;
  productGroupName: string;
}

export interface SBIndicators {
  sbIndicatorId: number;
  sbIndicator: string;
}

export interface LillyUsers {
  id: number;
  firstName: string;
  lastName: string;
  result: string;
  email: string;
  phone: string;
}

export interface ExpenseGrid {
  id: number;
  facultyExpenseExceptionId: number;
  expenseExceptionTypeId: number;
  exceptionType: string;
  activityId: number;
  exceptionDate: string;
  expenseNotifiedHowId: number;
  notifiedHow: string;
  comments: string;
  isUpdated: number;
  status: number;
}
export interface SBGrid {
  id: number;
  facultyKey: number;
  productGroupId: number;
  sbIndicatorKey: number;
  productGroupName: string;
  sbIndicator: string;
  blockFaculty: boolean;
  fdaProgram: number;
  brandKeys: string;
  blockingRuleKey: number;
  status: number;
}

export interface ppqYear {
  ppqInformationId: number;
  year: number;
}
export interface InitialRequesters {
  id: number;
  name: string;
  requesterName: string;
  email: string;
}
export interface compYear {
  id: number;
  year: string;
}
export interface fdaAllocation {
  facultyCompensationId: number;
  brandLimitId: number;
  activityTypeLimitId: number;
  brandGroupId: string;
  brandId: number;
  isAvailableAmountLinkVisible: boolean;
  isAvailableAmountAsteriskVisible: boolean;
  availableAmount: string;
  isAllocatedAmountLinkVisible: boolean;
  isAllocatedAmountAsteriskVisible: boolean;
  allocatedAmount: string;
  isUsedAmountLinkVisible: boolean;
  isUsedAmountAsteriskVisible: boolean;
  usedAmount: string;
  unSpecifiedAmount: string;
  activityTypeId: number;
  status: boolean;
}
export const handleSpecialtiesChange = (
  event: {target: {value: any}},
  specialties: string | any[],
  specialtiesName: string | any[],
  setSpecialtiesName: (arg0: any) => void,
  errorMsg: string,
) => {
  try {
    const {
      target: {value},
    } = event;
    if (value[value.length - 1] === CPSConstants.SMALL_ALL) {
      setSpecialtiesName(
        specialtiesName.length === specialties.length ? [] : specialties,
      );
      return;
    }
    setSpecialtiesName(value);
    return value;
  } catch (error: any) {
    loggedMessage(error, errorMsg, PageNames.FACULTY);
  }
};
export interface Divisions {
  division: string;
  divisionId: string;
}
export interface Area {
  area: string;
  areaId: number;
}
export interface District {
  district: string;
  districtKey: string;
}
export interface Territories {
  territory: string;
  territoryId: string;
}
export interface AlignmentRule {
  fieldAlignmentDetailId: number;
  fieldAlignmentId: number;
  fieldSubTypeLimitId: number;
  ruleType: string;
  fieldAlignmentTypeId: number;
  alignmentName: string;
  alignmentId: string;
  capAmount: number;
  usedAmount: number;
  availableAmount: number;
}
export interface SearchRepresentativesProps {
  individualKey: string;
  firstName: string;
  lastName: string;
  territoryId: string;
  territoryName: string;
}
export interface Representatives {
  individualKey: string;
  firstName: string;
  lastName: string;
  territoryId: string;
  territoryName: string;
}
export interface FacultyIntroVideoAlertsModel {
  alertDetails?: FacultyIntroVideoAlertDetail[] | null;
  totalRecordsCount: number;
  messageCode: number;
  message: string;
  isSuccessMessage: boolean;
  isErrorMessage: boolean;
  isValidationMessage: boolean;
}
export interface FacultyIntroVideoAlertDetail {
  facultyName: string;
  facultyFullName: string;
  credentials1: string;
  primarySpecialty: string;
  facultyId: number;
  videoURL: string;
  transcriptURL: string;
  submittedOn: string;
  alert?: FacultyIntroVideoAlert[] | null;
  alertActions?: FacultyIntroVideoAlert[] | null;
}

export interface FacultyIntroVideoAlert {
  alertId: number;
  approvalStatusId: number;
  brandDetail?: string | null;
  isReadOnly?: boolean | null;
}

export interface IntroVideoDetailGrid {
  videoURL: string;
  transcriptURL: string;
  submittedOn: Date;
  lastUpdatedBy: string;
  lastUpdatedWhen: Date;
  isFacultyVideoDisabled: boolean;
  brandDetail: string;
}

export interface OptoutResendResponse {
  showPopup: boolean;
  criteriaStatus: CriteriaStatusDetails;
  messageCode: number;
  message: string;
  isSuccessMessage: boolean;
  isErrorMessage: boolean;
  isValidationMessage: boolean;
}

export interface CriteriaStatusDetails {
  facultyVideoReTriggeredDate: Date;
  isContracted: boolean;
  isFacultyActive: boolean;
  isScreeningPass: boolean;
  isPPQApproved: boolean;
  isContractedBrandEnabled: boolean;
  isFacultyVideoOptedOut:boolean;
}
export interface RequestFromBrands {
  id: number;
  brandName: string;
  availableAmount: number;
  activityTypeId: number;
}
export interface OnBehalfApprovers {
  userKey: number;
  approverName: string;
}
export interface ActivitySubtypes {
  id: Number;
  description: string;
  status: Number;
  activityAssociation: boolean;
  isMedical: boolean;
  displayText: string;
}
export interface ContactNotesBrands {
  brandId: string;
  brandGroupId: string;
  availableAmount: number;
  capAmount: number;
  brandLimitId: number;
}
export interface ContactBrandNotes {
  notesId: number;
  dateAdded: string;
  addedBy: string;
  brand: string;
  subType: string;
  notes: string;
  description: string;
}
export interface AddedBy {
  profileId: number;
  addedBy: string;
}
